<template>
  <div>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <b-row class="align-top" style="display: flex; justify-content: flex-end">
      <!-- <b-col sm="1" class="dashboard-indicator-1"> -->
      <div
        sm="1"
        class="dashboard-indicator-1"
        @click="selectCard('card1')"
        :class="{ 'selected-card': selectedCard === 'card1' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Disponível')">
          <div class="dashboard-indicator-2 status-ok">
            <p class="dashboard-indicator-title status-font-color">
              {{ dashboard.disponivel }}
            </p>
            <p class="dashboard-indicator-category status-font-color">
              Disponível
            </p>
          </div>
        </a>
      </div>

      <div
        sm="1"
        class="dashboard-indicator-1"
        @click="selectCard('card2')"
        :class="{ 'selected-card': selectedCard === 'card2' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Aguardando início')">
          <div class="dashboard-indicator-2 status-pending">
            <p class="dashboard-indicator-title status-font-color">
              {{ dashboard.aguardando }}
            </p>
            <p class="dashboard-indicator-category status-font-color">
              Aguardando
            </p>
          </div>
        </a>
      </div>

      <div
        sm="1"
        class="dashboard-indicator-1"
        @click="selectCard('card3')"
        :class="{ 'selected-card': selectedCard === 'card3' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Em operação')">
          <div class="dashboard-indicator-2 status-iddle">
            <p class="dashboard-indicator-title status-font-color">
              {{ dashboard.emOperacao }}
            </p>
            <p class="dashboard-indicator-category status-font-color">
              Em operação
            </p>
          </div>
        </a>
      </div>
    </b-row>

    <b-row>
      <b-row>
        <b-col>
          <b-button size="sm" @click="cleanFilter">
            {{ $t("geral.cleanFilters") }}
          </b-button>
        </b-col>
      </b-row>
      <b-table
        ref="table"
        class="table-nowrap shLogStatusTrip"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :filter-debounce="700"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>

        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="field.key == 'statusStartDate'">
                <b-form-input
                  v-model="tableFilters[field.key]"
                  class="dateIndividual"
                  type="date"
                />
              </div>

              <div v-else-if="field.key == 'tempo'">
                <single-select
                  :value.sync="tableFilters.tempo"
                  :value-property="'value'"
                  :options="daysOptions"
                />
              </div>
              <div v-else-if="field.key == 'statusName'">
                <single-select
                  :value.sync="tableFilters.statusName"
                  :value-property="'value'"
                  :options="tripsStages"
                />
              </div>
              <div v-else-if="field.key == 'type'">
                <single-select
                  :value.sync="tableFilters.type"
                  :value-property="'value'"
                  :options="typeVechicleOptions"
                />
              </div>
              <div v-else>
                <b-form-input v-model="tableFilters[field.key]" />
              </div>
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(id)="cell">
          <div class="td-limitado">
            {{ cell.item.id }}
          </div>
        </template>

        <template v-slot:cell(tripId)="cell">
          <div v-if="cell.field.key == 'tripId'">
            <a
              class="status-font-color"
              href="#"
              @click.prevent="
                $refs.fillingDetails.show(
                  cell.item.tripId,
                  cell.item.stageId,
                  cell.item.CanComment == 'True'
                )
              "
            >
              # <u>{{ cell.item.tripId }}</u>
            </a>
          </div>
        </template>
      </b-table>
      <filling-details-modal
        ref="fillingDetails"
        :processName="'Programação'"
        :permissions="permissions"
      />
    </b-row>
  </div>
</template>
<script>
export default {
  name: "ShlogTripStatusList",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    FillingDetailsModal: () =>
      import("@/components_rms/workflow/WorkflowFilled/FillingDetailsModal.vue")
  },
  data: function() {
    return {
      alert: {
        error: "",
        success: ""
      },
      sortBy: "id",
      sortDesc: false,
      permissions: null,
      dashboard: {
        disponivel: 0,
        aguardando: 0,
        emOperacao: 0
      },
      fields: [
        {
          key: "id",
          filterKey: "id",
          label: "Placa",
          tdAttr: this.cellColorAttr,
          sortable: true,
          thStyle: {
            width: "184px"
          }
        },
        {
          key: "statusStartDate",
          filterKey: "statusStartDate",
          label: "Data de início",
          type: "date",
          sortable: true,
          thStyle: {
            width: "140px"
          },
          tdAttr: this.cellColorAttr,
          formatter: (value, key, item) => {
            const date = new Date(value);
            const dateTimeString = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
            return dateTimeString === "31/12/1969 21:00:00"
              ? ""
              : dateTimeString;
          }
        },
        {
          key: "tempo",
          label: "Tempo",
          type: null,
          filterKey: "tempo",
          sortable: true,
          tdAttr: this.cellColorAttr,
          thStyle: {
            width: "120px"
          },
          formatter: (value, key, item) => {
            return this.getElapsedTime(item.statusStartDate);
          }
        },
        {
          key: "type",
          filterKey: "type",
          label: "Tipo",
          type: "text",
          sortable: true,
          tdAttr: this.cellColorAttr,
          thStyle: {
            width: "120px"
          }
        },
        {
          key: "statusName",
          filterKey: "statusName",
          label: "Status",
          sortable: true,
          tdAttr: this.cellColorAttr,
          thStyle: {
            width: "120px"
          }
        },
        {
          key: "tripId",
          filterKey: "Viagem",
          label: "Viagem",
          sortable: true,
          tdAttr: this.cellColorAttr,
          thStyle: {
            width: "120px"
          }
        }
      ],
      isBusy: false,
      selectedCard: null,
      tableFilters: {
        id: "",
        tripId: "",
        statusStartDate: null,
        statusName: "",
        type: "",
        tempo: 0
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectedItem: [],
      tripsStages: [
        { value: "Disponível", text: "Disponível" },
        { value: "Aguardando início", text: "Aguardando início" },
        { value: "Em operação", text: "Em operação" }
      ],
      typeVechicleOptions: [
        { value: "Veículo", text: "Veículo" },
        { value: "Carreta 1", text: "Carreta 1" },
        { value: "Carreta 2", text: "Carreta 2" },
        { value: "Motorista", text: "Motorista" }
      ],
      daysOptions: [
        {
          value: 1,
          text: "1 dia"
        },
        {
          value: 5,
          text: "5 dias"
        },
        {
          value: 10,
          text: "10 dias"
        },
        {
          value: 20,
          text: "20 dias"
        }
      ]
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.$refs.table.refresh();
      if (this.dashboard.aguardando > 0) {
      }
    }, 240000);
    this.getPermissions();
  },
  methods: {
    async myProvider(ctx) {
      try {
        this.isBusy = true;

        const filters = this.createFilters();
        const url = this.createUrlList(filters, ctx);

        const response = await this.$apiWorkflow.get(url);
        const items = response.data;

        switch (this.tableFilters.statusName) {
          case "Disponível":
            this.dashboard.disponivel = 0;
            break;
          case "Aguardando início":
            this.dashboard.aguardando = 0;
            break;
          case "Em operação":
            this.dashboard.emOperacao = 0;
            break;
          default:
            this.dashboard.disponivel = 0;
            this.dashboard.aguardando = 0;
            this.dashboard.emOperacao = 0;
            break;
        }
        for (let fleet of items) {
          if (fleet.statusName) {
            switch (fleet.statusName.toUpperCase()) {
              case "DISPONÍVEL":
                this.dashboard.disponivel++;
                break;
              case "AGUARDANDO INÍCIO":
                this.dashboard.aguardando++;
                break;
              case "EM OPERAÇÃO":
                this.dashboard.emOperacao++;
                break;
              default:
                console.log("fleet.statusName: " + fleet.statusName);
                break;
            }
          }
        }
        this.isBusy = false;
        this.tableRowCount = response.data.length;
        return items;
      } catch (error) {
        console.log("Error");
        console.log(error);
        console.log(error.response);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.alert.error = error.message;
          this.$refs.danger.show();
          this.isBusy = false;
          this.tableRowCount = 0;
        }
        return [];
      }
    },
    createFilters() {
      const filters = {
        id: this.tableFilters.id,
        tripId: this.tableFilters.tripId,
        statusStartDate: this.tableFilters.statusStartDate,
        statusName: this.tableFilters.statusName,
        active: this.tableFilters.active,
        type: this.tableFilters.type,
        tempo: this.tableFilters.tempo,

        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      };
      return filters;
    },
    createUrlList(filters, ctx) {
      var url = `/shlog/fleet/status/list?sortBy=${ctx.sortBy}&sortDesc=${ctx.sortDesc}&`;
      url = this.appendFiltersOnUrl(url, filters);
      return url;
    },
    appendFiltersOnUrl(url, filters) {
      if (filters.id != null && filters.id != "") {
        url += `id=${filters.id}&`;
      }
      if (filters.tripId != null && filters.tripId != "") {
        url += `tripId=${filters.tripId}&`;
      }
      if (filters.statusName != null && filters.statusName != "") {
        url += `statusName=${filters.statusName}&`;
      }
      if (filters.statusStartDate != null && filters.statusStartDate != "") {
        url += `statusStartDate=${filters.statusStartDate}&`;
      }
      if (filters.type != null && filters.type != "") {
        url += `type=${filters.type}&`;
      }
      if (filters.tempo != null && filters.tempo != "") {
        url += `tempo=${filters.tempo}&`;
      }
      return url.substring(0, url.length - 1);
    },
    toggleDisponivel() {
      this.tableFilters.apenasChecklistGrisPendente = !this.tableFilters
        .apenasChecklistGrisPendente;
    },
    toggleAguardando() {
      this.tableFilters.apenasDocumentacaoPendente = !this.tableFilters
        .apenasDocumentacaoPendente;
    },
    toggleEmOperacao() {
      this.tableFilters.apenasViagensEmAndamento = !this.tableFilters
        .apenasViagensEmAndamento;
    },
    toggleStatusNameFilter(statusName) {
      if (this.tableFilters.statusName == statusName) {
        this.tableFilters.statusName = null;
      } else {
        this.tableFilters.statusName = statusName;
      }
    },
    getPermissions() {
      const workflowProcessId = 13;
      this.$apiWorkflow
        .get(
          `/
        ${workflowProcessId}`
        )
        .then(response => {
          this.permissions = response.data;
        });
    },
    getElapsedTime(startTime) {
      var endTime = new Date();

      var timeDiff = endTime - new Date(startTime);

      timeDiff /= 1000;

      var seconds = Math.round(timeDiff % 60);

      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      var minutesStr = minutes.toString().padStart(2, "0");

      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      var hoursStr = hours.toString().padStart(2, "0");

      timeDiff = Math.floor(timeDiff / 24);

      var days = timeDiff;

      var elapsedTimeStr = `${days}d ${hoursStr}h ${minutesStr}m`;

      if (elapsedTimeStr < "0d 00h 00m") {
        return "";
      }

      return elapsedTimeStr;
    },
    cellColorAttr(value, key, item) {
      return this.cellColorStyle(item);
    },
    cellColorStyle(item) {
      switch (item.statusName.toUpperCase()) {
        case "DISPONÍVEL":
          return {
            style: "color: white !important; background-color: #227a48;"
          };
        case "AGUARDANDO INÍCIO":
          return {
            style: "color: white !important; background-color: #df9101;"
          };
        case "EM OPERAÇÃO":
          return {
            style: "color: white !important; background-color: #132651;"
          };
      }
    },
    cleanFilter() {
      this.tableFilters = {
        id: "",
        tripId: "",
        statusStartDate: null,
        statusName: "",
        type: "",
        tempo: 0
      };
    },
    selectCard(cardId) {
      if (this.selectedCard === cardId) {
        this.selectedCard = null;
      } else {
        this.selectedCard = cardId;
      }
    }
  }
};
</script>

<style scoped>
.dashboard-indicator {
  background: #627180;
  border-radius: 0.2857rem;
  height: 140px;
  min-width: 100px;
  max-width: 100px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 0px !important;
  margin-right: 5px !important;
  text-align: center;
}
.dashboard-indicator-1 {
  padding-left: 1px;
  padding-right: 1px;
  margin-inline: 5px;
  /* margin-right: 50px; */
}
.selected-card {
  border: 2px solid white;
  border-radius: 0.3rem;
}
.dashboard-indicator-2 {
  border-radius: 0.2857rem;
  text-align: center;
  height: 145px;
  width: 125px;
}
.dashboard-indicator-title {
  font-size: 55px;
}
.dashboard-indicator-category {
  font-size: 12px;
}
.table-cell {
  padding-top: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
  padding-left: 7px;
  margin-top: -12px;
  margin-bottom: -12px;
  margin-right: -10px;
  margin-left: 1px;
}
.status-cell {
  text-align: center;
}
.status-ok {
  background-color: #227a48;
  color: white !important;
}
.status-iddle {
  background-color: #132651;
  color: white !important;
}
.status-pending {
  background-color: #df9101;
  color: black !important;
}

.status-font-color {
  color: white !important;
}

.td-limitado {
  max-width: 190px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}
.td-limitado:hover {
  overflow: visible !important;
  white-space: initial !important;
}
</style>
